/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { makeObservable } from 'mobx';

import config from 'utils/config';

import BaseLicenseStore from './LicenseStore.common';

class LicenseStore extends BaseLicenseStore {
  constructor() {
    super();

    makeObservable(this);
  }

  get expiresAt() {
    return config?.license?.expiresAt ?? undefined;
  }

  get isCommercialLicense() {
    return config?.license?.isCommercial ?? false;
  }

  get isDeveloperLicense() {
    return !this.isValidLicense;
  }

  get isValidLicense() {
    return config?.license?.isValid ?? false;
  }
}

export default new LicenseStore();
